import { FormInstance } from "antd";
import { makeAutoObservable } from "mobx";
import { ZObjectRefSelector } from "src/common/attrEdit/components";
import { loadAttrTypeMap } from "src/common/attributes";
import { getObjectRefAttrLabelsMap } from "src/common/attributes/makeAttrLabel/labelMakers/object/ObjectRefLabel/getObjectRefAttrLabelsMap";
import { ZAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { onError } from "src/common/onError";

import { EntFilterActionType } from "src/pages/EntityFiltersPage/EntityFiltersPage.types";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { EntitySelectTableStore } from "../EntitySelectTable/EntitySelectTableStore";
import { filterObjectRefLabelTreeData } from "./filterObjectRefLabelTreeData";

export class ObjectRefSelectorStore {
  constructor(
    readonly attribute: ZAttribute,
    private labelsData?: ZAttrLabelsData,
  ) {
    makeAutoObservable(this);
  }

  entitySelectStore: EntitySelectTableStore | null = null;

  setEntitySelectStore(store: EntitySelectTableStore) {
    this.entitySelectStore = store;
  }

  setLabelsData(data: ZAttrLabelsData | undefined) {
    this.labelsData = data;
  }

  component: ZObjectRefSelector | null = null;

  setComponent(data: ZObjectRefSelector) {
    this.component = data;
  }

  loading: boolean = false;

  setLoading(flag: boolean) {
    this.loading = flag;
  }

  typesMap: Record<number, string> = {};

  setTypesMap(map: Record<number, string>) {
    this.typesMap = map;
  }

  get calculatedLabelsMap() {
    if (!this.labelsData) return {};
    return getObjectRefAttrLabelsMap(
      this.attribute,
      this.labelsData.labels,
      this.component?.labelAtts || [],
    );
  }

  async init(
    attribute: ZAttribute,
    component: ZObjectRefSelector,
    multiple: boolean,
    form: FormInstance,
    value?: string[],
    onChange?: (value?: string[]) => void,
    entityId?: ZUid,
  ) {
    try {
      this.setLoading(true);
      this.setEntitySelectStore(new EntitySelectTableStore(onChange));
      await this.entitySelectStore?.init({
        attribute,
        multiple,
        form,
        value,
        entityId,
        actionsList: component.isCreateButtonAvailable
          ? [EntFilterActionType.create]
          : [],
        actionsMeta: {
          useModal: component.useModal,
        },
      });
      this.setComponent(component);
      this.setTypesMap(await loadAttrTypeMap());
      this.setLabelsData(
        filterObjectRefLabelTreeData(this.labelsData, this.typesMap),
      );
    } catch (error) {
      onError(error);
    } finally {
      this.setLoading(false);
    }
  }
}
